<dialog-wrapper
  [backgroundColor]="'#41474f'"
  [dialogTitle]="'Manage Contact'"
  [smallTitle]="true"
  [titleHeight]="40"
  [giveMeTwenty]="true"
  [maxHeight]="maxHeight"
  [deleteLeft]="true"
  [showClose]="false"
  [successLabel]="'SAVE'"
  [disabled]="false"
  [style.--pagebackground]="template.pagebackground"
  [style.--font]="FontCSS[template.font]"
  [style.--header-font]="FontCSS[template.headerFont]"
  [style.--primary]="template.primary"
  [style.--primaryhover]="template.primaryhover"
  [style.--link]="template.link"
  [style.--contentbg]="template.contentbg"
  [style.--contentbgoutline]="template.contentbgoutline"
  [style.--innercontentbg]="template.innercontentbg"
  [style.--innercontentbgoutline]="template.innercontentbgoutline"
  (delete)="delete($event)"
  (submit)="close()">
  <div class="top-top" *ngIf="{ isPrimary: resource.primaryContactId === contact.id } as vars">
    <h3>Contact of {{ resource.name || 'Unnamed resource' }}</h3>
    <toggle-tab [text]="'Is primary contact: '"
      [borderless]="true" [toggled]="vars.isPrimary" (toggle)="togglePrimaryContact()"></toggle-tab>
  </div>
  <div class="top">
    <image-uploader 
      [id]="contact.id"
      [publishCode]="data.publishCode"
      (newUrls)="changeUrls($event)"
      [immediate]="true" 
      [isLogo]="true"
      [displayType]="imageUploaderDisplayTypes.card"
      [thumbUrl]="contact.photoURL" 
      [photoUrl]="contact.photoURL"
      [eventId]="data.eventId"
      [type]="'resource'" 
      [subtype]="'photo'" 
      [isTemplate]="data.fromTemplate"
      [public]="data.public"
      [placeholder]="'Add photo'" 
      [uploadText]="'UPLOAD PHOTO'"
      [saveName]="contact.firstName + ' ' + contact.lastName"
    ></image-uploader>
    <div class="right">
      <mutating-input [object]="contact" [prop]="'firstName'" [placeholder]="'First name'"></mutating-input>
      <mutating-input [object]="contact" [prop]="'lastName'" [placeholder]="'Last name'"></mutating-input>
      <mutating-input [object]="contact" [prop]="'role'" [placeholder]="'Role'"></mutating-input>
      <mutating-input [object]="contact" [prop]="'phone'" [placeholder]="'Mobile'"></mutating-input>
      <mutating-input [object]="contact" [prop]="'email'" [placeholder]="'Email'"></mutating-input>
    </div>
  </div>
  <mutating-input [object]="contact" [isArea]="true" [prop]="'aboutMe'" [placeholder]="'About me'"></mutating-input>
  <mutating-input [object]="contact" [isArea]="true" [prop]="'address'" [placeholder]="'Address'"></mutating-input>
</dialog-wrapper>